import type { TransactionTypes } from "@/modules/transaction/common/enum";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface CommonState {
  accountActiveTab: string,
  beneficiaryActiveTab: string,
  loanActiveTab: string,
  cardId?: string | number;
  accountId?: string | number;
  loanId?: string | number;
  transactionId?: string | number;
  applicationId?: string | number;
  depositId?: string | number;
  beneficiaryId?: string | number;
  activeTransactionType?: TransactionTypes | string;
  hasUnsavedChanges: boolean;
  pendingSignOut: boolean;
}

const initialState: CommonState = {
  accountActiveTab: "",
  beneficiaryActiveTab: "",
  loanActiveTab: "",
  cardId: "",
  accountId: "",
  loanId: "",
  transactionId: "",
  applicationId: "",
  depositId: "",
  beneficiaryId: "",
  activeTransactionType: "",
  hasUnsavedChanges: false,
  pendingSignOut: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setActiveCardId(state, { payload }: PayloadAction<string | number | null>) {
      state.cardId = payload || "";
    },
    setActiveAccountId(state, { payload }: PayloadAction<string | number | null>) {
      state.accountId = payload || "";
    },
    setActiveLoanId(state, { payload }: PayloadAction<string | number | null>) {
      state.loanId = payload || "";
    },
    setActiveTransactionId(state, { payload }: PayloadAction<string | number | null>) {
      state.transactionId = payload || "";
    },
    setActiveApplicationId(state, { payload }: PayloadAction<string | number | null>) {
      state.applicationId = payload || "";
    },
    setActiveDepositId(state, { payload }: PayloadAction<string | number | null>) {
      state.depositId = payload || "";
    },
    setAccountActiveTab(state, { payload }: PayloadAction<string | null>) {
      state.accountActiveTab = payload || "";
    },
    setBeneficiaryActiveTab(state, { payload }: PayloadAction<string | null>) {
      state.beneficiaryActiveTab = payload || "";
    },
    setActiveBeneficiaryId(state, { payload }: PayloadAction<string | number | null>) {
      state.beneficiaryId = payload || "";
    },
    setLoanActiveTab(state, { payload }: PayloadAction<string | null>) {
      state.loanActiveTab = payload || "";
    },
    setActiveTransactionType(
      state,
      { payload }: PayloadAction<TransactionTypes | string | null>
    ) {
      state.activeTransactionType = payload || "";
    },
    setHasUnsavedChanges(state, { payload }: PayloadAction<boolean>) {
      state.hasUnsavedChanges = payload;
    },
    setPendingSignOut(state, { payload }: PayloadAction<boolean>) {
      state.pendingSignOut = payload;
    },
  },
});

export const {
  setAccountActiveTab,
  setLoanActiveTab,
  setActiveCardId,
  setActiveAccountId,
  setActiveLoanId,
  setActiveTransactionId,
  setActiveApplicationId,
  setActiveDepositId,
  setActiveTransactionType,
  setHasUnsavedChanges,
  setPendingSignOut,
  setActiveBeneficiaryId,
  setBeneficiaryActiveTab,
} = commonSlice.actions;
export default commonSlice.reducer;
